module.exports = __webpack_public_path__ + "img/V-R-5-load-standup-shadow.2e784a75.png";